export default __webpack_public_path__ + "static/media/Group7553.99890090.png";